// extracted by mini-css-extract-plugin
export default {"ContainerError":"classesErrorHandler_ContainerError__0jtBf","TitleError":"classesErrorHandler_TitleError__OpH3u","ErrorBody":"classesErrorHandler_ErrorBody__yf39N"};